
import { Component, Vue, Prop } from 'vue-property-decorator';
import BaseCard from '@/components/base/BaseCard.vue';
import ViewDateTime from '@/components/base/ViewDateTime.vue';
import Status from '@/components/base/Status.vue';
import StarOutlined from '@/assets/icons/star-outlined.svg';
import { IEmployeeAffiliateMethod } from '@/api/types/payout';
import BaseList from '@/components-UI/list/BaseList.vue';
import BaseListItem from '@/components-UI/list/BaseListItem.vue';
import BaseInputNumber from "@/components-UI/BaseInputNumber.vue";

@Component({
    components: {
        BaseInputNumber,
        BaseCard,
        ViewDateTime,
        Status,
        StarOutlined,
        BaseList,
        BaseListItem,
    },
})
export default class PayoutMethodInfo extends Vue {
    @Prop({ required: true }) employeeAffiliateMethod!: IEmployeeAffiliateMethod;
    @Prop({ required: true }) isEdit!: boolean;
    @Prop({ required: true }) personalCommissionValue!: number | null;
    @Prop({ required: true }) partnerCommissionValue!: number | null;
    @Prop({ required: true }) compensationValue!: number | null;

    get getAffiliateRouteText(): { name: string, id: number | string } {
        const affiliate = this.employeeAffiliateMethod.affiliate_id ?
            `${this.employeeAffiliateMethod.affiliate_id} ${this.employeeAffiliateMethod.affiliate_name}` : '';

        return {
            name: affiliate,
            id: this.employeeAffiliateMethod.affiliate_id,
        };
    }

    get getAffiliateManager(): string {
        const { affiliate_manager } = this.employeeAffiliateMethod;
        return affiliate_manager ? `${affiliate_manager.first_name} ${affiliate_manager.last_name}` : '';
    }

    getPercentValue(value: number | null): string {
        return value ? `${value.toLocaleString('ru-RU', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
        })} %` : value === 0 ? '0 %' : ' Не указано';
    }

    get getOurCommission(): string {
        let value: number | null = null;

        if (this.isEdit) {
            value = (this.personalCommissionValue ?? 0) - (this.partnerCommissionValue ?? 0);
        } else {
            const { our_commission, partner_commission, commission } = this.employeeAffiliateMethod;
            if (our_commission) {
                value = our_commission * 100;
            } else if (commission && partner_commission) {
                value = (commission - partner_commission) * 100;
            }
        }

        if (value === null) {
            return 'Не указано';
        }

        return `${value.toLocaleString('ru-RU', { maximumFractionDigits: 2, minimumFractionDigits: 2 })} %`;
    }

    get getPaymentMethod(): string {
        const { method } = this.employeeAffiliateMethod;
        return method?.name?.ru ? method?.name?.ru : '';
    }

    get isNotDefault(): boolean {
        return this.employeeAffiliateMethod.is_default === false &&
            this.employeeAffiliateMethod.status === 'approved';
    }

    updatePersonalCommission(value: number | null): void {
        this.$emit('update-personal-commission', value);
        if (value === null) {
            this.$emit('update-partner-commission', null);
        }
    }
}
